import React, { ReactNode, useCallback, useState } from 'react';
import { Drawer } from 'antd';
import { useWindowSize } from '../../hooks/useWindowSize';
import Navbar, { NavbarProps } from '../Navbar';
import Toolbar, { ToolbarProps } from '../Toolbar';
import IconHamburger from '../Icons/IconHamburger';
import IconCloseOutlined from '../Icons/IconCloseOutlined';
import './Header.less';

export type HeaderProps = {
  logo?: ReactNode;
  avatar?: ReactNode;
  navigation?: NavbarProps['navigation'];
  toolbar?: ToolbarProps['items'];
  accountSwitcher?: ReactNode;
  drawer?: any;
  current?: any;
  setCurrent?: any;
  onClick?: any;
  onOpenChange?: any;
  height?: string;
  theme?: 'dark' | 'light';
};

const Header: React.FC<HeaderProps> = ({
  logo,
  avatar,
  navigation,
  toolbar,
  accountSwitcher,
  drawer,
  current,
  setCurrent,
  onClick,
  onOpenChange,
  height,
  theme,
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);

  const size = useWindowSize();
  const mobile = size.width < 769;

  const handleOpenDrawer = useCallback(() => {
    setDrawerVisible(true);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setDrawerVisible(false);
  }, []);

  const handleOpenMobileDrawer = useCallback(() => {
    setMobileDrawerVisible(true);
  }, []);

  const handleCloseMobileDrawer = useCallback(() => {
    setMobileDrawerVisible(false);
  }, []);

  return (
    <div className="t-header t-header-horizontal">
      {!mobile && <div className="t-logo t-logo-desktop">{logo}</div>}
      <nav>
        <div className="t-toggle-button" onClick={handleOpenDrawer}>
          <IconHamburger size="md" fill="currentColor" />
        </div>
        <Navbar
          mode="horizontal"
          navigation={navigation}
          setCurrent={setCurrent}
          current={current}
          onClick={onClick}
          height={height}
          onOpenChange={onOpenChange}
        />
        <Drawer
          title={logo}
          placement="left"
          visible={drawerVisible}
          onClose={handleCloseDrawer}
          closeIcon={<IconCloseOutlined size="md" fill="currentColor" />}
        >
          <Navbar
            theme={theme}
            mode="vertical"
            onClick={handleCloseDrawer}
            navigation={navigation}
            setCurrent={setCurrent}
            current={current}
            // onClick={onClick}
            height={height}
            onOpenChange={onOpenChange}
          />
        </Drawer>
      </nav>
      {mobile && <div className="t-logo t-logo-mobile">{logo}</div>}
      {!mobile ? (
        <>
          {accountSwitcher || null}
          <Toolbar mode="horizontal" items={toolbar} onClick={onClick} />
        </>
      ) : (
        <>
          {accountSwitcher || null}
          <div className="t-toggle-button" onClick={handleOpenMobileDrawer}>
            {avatar}
          </div>
          <Drawer
            title={<div className="mobile_drawer_avatar">{avatar}</div>}
            placement="right"
            className="mobile_drawer"
            visible={mobileDrawerVisible}
            onClose={handleCloseMobileDrawer}
            closeIcon={<IconCloseOutlined size="md" fill="currentColor" />}
          >
            <Navbar
              mode="vertical"
              navigation={drawer}
              setCurrent={setCurrent}
              current={current}
              onClick={handleCloseMobileDrawer}
              height={height}
              onOpenChange={onOpenChange}
              theme={theme}
            />
          </Drawer>
        </>
      )}
    </div>
  );
};

export default Header;
